var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9688 9.2192C19.3912 7.56632 18.3139 6.13394 16.8862 5.12044C15.4585 4.10695 13.7509 3.5625 12 3.5625C10.2491 3.5625 8.54156 4.10695 7.11382 5.12044C5.68608 6.13394 4.60883 7.56632 4.03125 9.2192M19.9688 9.2192C20.2725 10.0892 20.4375 11.0248 20.4375 11.9989C20.4386 12.9455 20.2801 13.8855 19.9688 14.7795M19.9688 9.2192H4.03125M4.03125 9.2192C3.72001 10.1129 3.56154 11.0526 3.5625 11.9989C3.56149 12.9455 3.71996 13.8855 4.03125 14.7795M19.9688 14.7795C19.3912 16.4324 18.3139 17.8648 16.8862 18.8783C15.4585 19.8918 13.7509 20.4362 12 20.4362C10.2491 20.4362 8.54156 19.8918 7.11382 18.8783C5.68608 17.8648 4.60883 16.4324 4.03125 14.7795M19.9688 14.7795H4.03125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9688 9.2192C19.3912 7.56632 18.3139 6.13394 16.8862 5.12044C15.4585 4.10695 13.7509 3.5625 12 3.5625C10.2491 3.5625 8.54156 4.10695 7.11382 5.12044C5.68608 6.13394 4.60883 7.56632 4.03125 9.2192M19.9688 9.2192C20.2725 10.0892 20.4375 11.0248 20.4375 11.9989C20.4386 12.9455 20.2801 13.8855 19.9688 14.7795M19.9688 9.2192H4.03125M4.03125 9.2192C3.72001 10.1129 3.56154 11.0526 3.5625 11.9989C3.56149 12.9455 3.71996 13.8855 4.03125 14.7795M19.9688 14.7795C19.3912 16.4324 18.3139 17.8648 16.8862 18.8783C15.4585 19.8918 13.7509 20.4362 12 20.4362C10.2491 20.4362 8.54156 19.8918 7.11382 18.8783C5.68608 17.8648 4.60883 16.4324 4.03125 14.7795M19.9688 14.7795H4.03125",
    stroke: "url(#paint0_linear_1637_4777)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0023 20.4375C16.6617 15.7781 16.6617 8.22188 12.0023 3.5625C7.34297 8.22188 7.34297 15.7781 12.0023 20.4375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0023 20.4375C16.6617 15.7781 16.6617 8.22188 12.0023 3.5625C7.34297 8.22188 7.34297 15.7781 12.0023 20.4375Z",
    stroke: "url(#paint1_linear_1637_4777)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1637_4777",
    x1: 12,
    y1: 3.5625,
    x2: 12,
    y2: 20.4362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90B3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1637_4777",
    x1: 12.0023,
    y1: 3.5625,
    x2: 12.0023,
    y2: 20.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90B3E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotIcon3);
export default __webpack_public_path__ + "static/media/spotIcon3.46b59ac49c2cdd6f14f9e152a9955002.svg";
export { ForwardRef as ReactComponent };